exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dataTable-static td>button{padding:0 12px}.dataTable-static thead{font-size:.9em}.form-group-list h3,.form-group-list h4{margin-bottom:20px;margin-top:20px;margin-left:10px}.mbottom-20{margin-bottom:20px}.mtop-20{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/asistencias/form/form.scss
// module id = 1305
// module chunks = 0